import React, { useEffect } from 'react';

//componets
import FlNav from './landingComponents/Navbar';
import FlFooter from './landingComponents/Footer';

//Mansory - Bento grid
import Masonry from 'react-masonry-css';

//Iconos
import icn_01 from '../../assets/img/landingPage/playground/icn_Playground-01.png';
import icn_02 from '../../assets/img/landingPage/playground/icn_Playground-02.png';
import icn_03 from '../../assets/img/landingPage/playground/icn_Playground-03.png';



import fondo from '../../assets/img/landingPage/fondo.png';
import ReactGA from 'react-ga4'
import logo from '../../assets/img/logos/AVAP_Playgraund_negativo.svg'

import Favicon from '../../assets/img/Favicon_AVAP_Framework.png'

//Importaciones de otros archivos, revisar y borrar
import gradientApi from '../../assets/img/landingPage/gradientApi.png'
import gradientServices from '../../assets/img/landingPage/gradientServices.png'

import product_gateway from '../../assets/img/landingPage/Gateway.png'
import dashboard from '../../assets/img/landingPage/playground/playground_dashboard.png';

import icn_vision from '../../assets/img/landingPage/about/aboutUs_vision.svg';
import icn_mision from '../../assets/img/landingPage/about/aboutUs_mision.svg';


const Playground = () => {


    useEffect(() =>{

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true){
            ReactGA.initialize('G-08SZKPG9V0');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: '101OBEX, CORP About Page' });
            }

    }, [])


    useEffect(() =>{

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true){
            ReactGA.initialize('G-08SZKPG9V0');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: '101OBEX, CORP About Page' });
            }

    }, [])

    useEffect(() => {
        // favicon 
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = Favicon; // Usa la ruta importada directamente
        document.head.appendChild(link);
    
        // clean favicon 
        return () => {
          document.head.removeChild(link);
        };
      }, []);

    useEffect(() => {

        document.body.classList.add('dark-bg');
        return () => {
            document.body.classList.remove('dark-bg');
        };

    }, []);

    const productDetailsA = {
        Key_Feature_01: {
            title: 'A playful first step into programming',
            text: "AVAP Playground introduces software development for kids aged 5 to 8 through a visual, block-based interface. Inspired by STEM education and powered by Microsoft + AVAP technologies, learning becomes fun and intuitive, turning coding into a game kids love.",
            altDescription: "AVAP Playground introduces software development for kids aged 5 to 8 through a visual, block-based interface. Inspired by STEM education and powered by Microsoft + AVAP technologies, learning becomes fun and intuitive, turning coding into a game kids love.",
            image: icn_01,
        },
        Key_Feature_02: {
            title: "Fun with lasting learning impact",
            text: "AVAP Playground nurtures creativity, logic, and computational thinking. Perfect for at-home exploration, after-school programs, or community activities, it gives children a safe, engaging way to experiment and learn at their own pace.",
            altDescription: "AVAP Playground nurtures creativity, logic, and computational thinking. Perfect for at-home exploration, after-school programs, or community activities, it gives children a safe, engaging way to experiment and learn at their own pace.",
            image: icn_02,
        },
        Key_Feature_03: {
            title: 'Flexible, safe, and ready for any setting',
            text: "Whether at home or in educational programs, AVAP Playground is easy to set up, free to use, and designed to spark curiosity in every child, regardless of location, resources, or experience.",
            altDescription: 'Whether at home or in educational programs, AVAP Playground is easy to set up, free to use, and designed to spark curiosity in every child, regardless of location, resources, or experience.',
            image: icn_03,
        },
    }
      

    return (
        <>
            <FlNav></FlNav>
            <div id="pricing"
            className="fl-cloud-product bg-black text-white"
            style={{ backgroundImage: `url(${fondo})` }}
            >
                {/* Hero Section */}
                <section id="heroProduct" 
                className="text-center pt-5">
                    <img
                        src={logo}
                        alt="Logo AVAP Cloud"
                        className="img-fluid logo"
                    />
                    <h1 className="fl-title m-0">Learn to Code. Play to Grow.</h1>
                    <p className="fl-subtitle pb-4 fl-txt-container-s">
                    Introduce young minds to the world of software architecture through creativity and play.
                    </p>
                </section>

                {/* Powerful API Platform */}
                <section className="text-center pb-8">
                    <img
                        src={dashboard}
                        alt="AVAP Cloud illustration displaying API Manager Service components including Devs & Organizations, Managed APIs, IAM, credentials, API Projects, API Catalog, Dev Portal, Gateway Manager, BRUNIX AI, and AI analytics."
                        className="img-fluid mt-4"
                        style={{ width: '80%', maxWidth: '900px', height: 'auto' }}
                    />
                    <h2 className="fl-title m-4 pt-8">AVAP Playground: Building Tomorrow’s Thinkers Today</h2>
                    {/*<p className="fl-subtitle-xs mb-3">
                        Manage the entire API lifecycle in a SaaS model from <br /> design to testing and deployment.
                    </p>*/}
                    <p className="fl-text fl-txt-container-s">
                    Give your kids the tools to explore technology and logic in a fun, hands-on way! AVAP Playground combines playful, block-based programming with learning, helping children aged 5 to 8 understand the basics of software architecture while having a blast. Designed to fit any learning environment, it’s more than a tool, it’s the first step in a lifelong journey with technology.
                    </p>
                    {/*Boton Contact Us*/}  
                    <a className="glowBtn-dark " style={{zIndex: 2}} href="/contact" target='_blank'><span className="btnInner">   Start Now  </span></a> 
                </section>

                

                {/* Sección Key Features */}
                <div className="fl-wrapper">
                    <img src={gradientServices} className="gradient gradientServices" alt="" />
                    <img src={gradientApi} alt="" className="gradient gradientlife" />
                    <div className="fl-container">
                        <section id="products">
                            {/*   <h3 className="fl-title text-center">Our Products & Services</h3> */}
                            <br />
                            &nbsp;
                            <br />&nbsp;
                            <p className="fl-title-center m-0">Key Features</p>
                            <div className="fl-productsWrapper">
                                {Object.keys(productDetailsA).map((productKey, index) => (
                                    <div key={productKey} className="fl-product-item">
                                        <div className={`row align-items-center ${index % 2 === 0 ? '' : 'flex-row-reverse'}`}>
                                            <div className="col-md-9">
                                                <div className="product-content">
                                                    <h3 className="fl-subtitle">
                                                        {productDetailsA[productKey].title}
                                                    </h3>
                                                    <p className="fl-text">
                                                        {productDetailsA[productKey].text}
                                                    </p>
                                                    
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <img
                                                    src={productDetailsA[productKey].image}
                                                    alt={productDetailsA[productKey].altDescription}
                                                    className="img-fluid product-preview"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            {/*Boton Contact Us*/}  
                            <a className="glowBtn-dark " style={{zIndex: 2}} href="/contact" target='_blank'><span className="btnInner">Start Exploring for Free</span></a> 
                        </section>
                    </div>
                </div>

                <br />
                <br />
            </div>
            <FlFooter></FlFooter>
        </>
    );
};
export default Playground;
